import * as ax from "../instrance";
import config from "../../../config/config.js";
var URL = config.apiUrl;

// 获取当前登录用户角色权限
export const getUserMenusList = params => {
  return ax.pJson(URL + "/back/settings/getUserMenusList", params);
};

export const getUserButtonsList = params => {
  return ax.pJson(URL + "/back/settings/getUserButtonsList", params);
};



// WEBPACK FOOTER //
// ./src/api/userApi/userAx.js